import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "input-container__inner" }
const _hoisted_3 = {
  key: 0,
  class: "input-value"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["id", "name", "value"]
const _hoisted_8 = {
  key: 0,
  class: "error-msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["input-container", { error: !!_ctx.error, required: _ctx.required }])
    }, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: _ctx.id
          }, [
            _createVNode(_component_TranslatedText, { path: _ctx.label }, null, 8, ["path"])
          ], 8, _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "dropdown",
          tabindex: "0",
          onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleKeyUp && _ctx.handleKeyUp(...args)))
        }, [
          _createElementVNode("div", {
            class: "input",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = !_ctx.open))
          }, [
            (_ctx.selectedItem)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_ctx.selectedItem.image)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.selectedItem.image
                      }, null, 8, _hoisted_4))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, _toDisplayString(_ctx.selectedItem.text), 1)
                ]))
              : _createCommentVNode("", true),
            _cache[3] || (_cache[3] = _createElementVNode("span", null, ">", -1))
          ]),
          _createElementVNode("ul", {
            class: _normalizeClass({ open: _ctx.open })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDropdownItems, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.value,
                onClick: ($event: any) => (_ctx.handleChange(item))
              }, [
                (item.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: item.image
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, _toDisplayString(item.text), 1)
              ], 8, _hoisted_5))
            }), 128))
          ], 2)
        ], 32),
        _createElementVNode("input", {
          id: _ctx.id,
          name: _ctx.name,
          value: _ctx.value.number,
          class: _normalizeClass({ error: !!_ctx.error }),
          type: "tel",
          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
        }, null, 42, _hoisted_7)
      ])
    ], 2),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_TranslatedText, { path: _ctx.error }, null, 8, ["path"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}